import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidReadingBasisHomeworkMode } from '../../../../mechanics/rid-reading-basis-homework-mode/rid-reading-basis-homework-mode';

@Component({
  selector: 'app-reading-basis-homework-mode-per-soundfoot-page',
  imports: [RidReadingBasisHomeworkMode],
  templateUrl: './reading-basis-homework-mode-per-soundfoot-page.html',
})
export class ReadingBasisHomeworkModePerSoundfootPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly pace = () => parseInt(this.$activatedRoute.snapshot.queryParams['pace'] ?? '500');
  protected readonly pause = () => parseInt(this.$activatedRoute.snapshot.queryParams['pause'] ?? '500');
}
